module.exports = __webpack_public_path__ + "img/slide4.51078387.jpg";